// Supermove
import {gql} from '@supermove/graphql';
import {withFragment} from '@supermove/utils';

// App
import CompensationReportStatus from '@shared/modules/Accounting/enums/CompensationReportStatus';
import UserRole from '@shared/modules/User/enums/UserRole';

const getRole = withFragment(
  (cost) => {
    const role = (cost as any).moverPosition
      ? (cost as any).moverPosition.role
      : (cost as any).compensationUser.role;
    return UserRole.getDisplayRole(role);
  },
  gql`
    fragment Cost_getRole on Cost {
      id
      moverPosition {
        id
        role
      }
      compensationUser {
        id
        role
      }
    }
  `,
);

const getHasBalanceDue = withFragment(
  (cost) => {
    const remainingBalance = (cost as any).total - (cost as any).paidOutAmount;
    return (cost as any).isPaidOut && remainingBalance > 0;
  },
  gql`
    fragment Cost_getHasBalanceDue on Cost {
      id
      isPaidOut
      total
      paidOutAmount
    }
  `,
);

const getRemainingBalance = withFragment(
  (cost) => {
    return (cost as any).total - (cost as any).paidOutAmount;
  },
  gql`
    fragment Cost_getRemainingBalance on Cost {
      id
      total
      paidOutAmount
    }
  `,
);

const getIsPaidOutOption = withFragment(
  (cost) => {
    const status = (cost as any).isPaidOut
      ? CompensationReportStatus.PAID_OUT
      : CompensationReportStatus.NOT_PAID_OUT;
    // @ts-expect-error   No index signature with a parameter of type 'string' was found on type
    return CompensationReportStatus.STATUS_OPTION_MAP[status];
  },
  gql`
    fragment Cost_getIsPaidOutOption on Cost {
      id
      isPaidOut
    }
  `,
);

const getDisplayIdentifier = withFragment(
  (cost) => {
    return (cost as any).job
      ? `${(cost as any).job.jobType.name}: ${(cost as any).job.identifier}`
      : `Project ${(cost as any).project.identifier}`;
  },
  gql`
    fragment Cost_getDisplayIdentifier on Cost {
      id
      job {
        id
        identifier
        jobType {
          id
          name
        }
      }
      project {
        id
        identifier
      }
    }
  `,
);

const Cost = {
  getRole,
  getHasBalanceDue,
  getRemainingBalance,
  getIsPaidOutOption,
  getDisplayIdentifier,
};

export default Cost;
